
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/telecommunications/page/[id]",
      function () {
        return require("private-next-pages/cases/telecommunications/page/[id].tsx");
      }
    ]);
  